import { Typography } from '@mui/material';

interface TurnStateTextProps {
    text: string;
}
const TurnStateText = (props: TurnStateTextProps) => {
    return (
        <Typography variant={'h5'} color={'white'} textTransform="none" sx={{ textShadow: '0 0 15px rgba(193, 145, 255, 0.4)' }}>
            {props.text}
        </Typography>
    );
};

export default TurnStateText;
